import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Button } from 'primeng/button';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  user: any;
  isLoading = true;

  constructor(private authService: AuthService, private router: Router) {
    this.user = this.authService.getUser();
  }

  ngOnInit(): void {
    this.authService.isLoadingUserInfo$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(loading => {
      this.isLoading = loading;
    });

    this.authService.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => {
      this.user = user;
      if (user && this.router.url === '/unauthorized') {
        this.redirectByRole(user);
      }
    });
  }

  private redirectByRole(user: any): void {
    if (user.isAdmin || user.isPM) {
      this.router.navigate(['/dashboard/portfolio-overview']);
    } else if (user.isFinance) {
      this.router.navigate(['/allocations']);
    } else if (user.isPc) {
      this.router.navigate(['/employees']);
    } else if (user.isSales) {
      this.router.navigate(['/presales/summary']);
    } else if (user.isSoftware || user.isAccounting || user.isMarketing || user.isOperations || user.isSupport) {
      this.router.navigate(['/timesheet']);
    } else if (user.isIt || user.isLnD) {
      this.router.navigate(['/onboarding/employees']);
    }
  }

  logout(): void {
    this.authService.localLogout();
    this.router.navigate(['/login']);
  }
}

